<template>
	<div class="requires-extension-message-box flex-start--center font-size-md pa-3">
		<div class="left-side pr-4">
			<svg xmlns="http://www.w3.org/2000/svg" width="20.714" height="18.752" viewBox="0 0 20.714 18.752">
				<g id="Group_45838" data-name="Group 45838" transform="translate(0 0)">
					<g id="Group_45843" data-name="Group 45843">
						<path
							id="Path_32957"
							data-name="Path 32957"
							d="M7.757,1.5a3,3,0,0,1,5.2,0l7.355,12.748a3,3,0,0,1-2.6,4.5H3a3,3,0,0,1-2.6-4.5Z"
							transform="translate(0 0)"
							fill="#6061d8"
							fill-rule="evenodd"
						/>
						<path
							id="Path_32958"
							data-name="Path 32958"
							d="M10.357,5.229a1.027,1.027,0,0,1,1.027,1.028v5.135a1.027,1.027,0,0,1-2.054,0V6.257a1.027,1.027,0,0,1,1.027-1.028m0,11.3A1.027,1.027,0,1,0,9.33,15.5a1.027,1.027,0,0,0,1.027,1.027"
							transform="translate(0 0)"
							fill="#fff"
							fill-rule="evenodd"
						/>
					</g>
				</g>
			</svg>
		</div>
		<div class="right-side">
			<div class="font-weight-500">This feature requires the Ply extension</div>
			<div class="description font-weight-300">Get the extension <a @click="goToChromeStore" href="#">here</a> in the Chrome store.</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'RequiresExtensionMessageBox',
	methods: {
		goToChromeStore() {
			const { VUE_APP_CHROME_EXTENSION_APP_URL: chromeAppURL } = process.env;
			window.open(chromeAppURL, '_blank');
		},
	},
};
</script>

<style scoped lang="scss">
.requires-extension-message-box {
	background-color: var(--sub-title-background);
	border: 1px solid #e2e7f0;
	border-radius: 5px;

	.description {
		color: var(--dismiss-all-grey-color);
	}
}
</style>
